module.exports = __webpack_public_path__ + "img/the2.5c0056cc.png";